<template>
  <div class="page-wrapper">
    <div class="row">
      <div class="col-md-6">
        <div class="role-container">

          <!-- Header -->
          <div class="page-header">
            <div class="pb-3">
              <h3>App Resource List</h3>
              <!-- <p>Manage role based access privileges</p> -->
            </div>

            <!-- <button class="save-btn" @click="saveChanges">
              <i class="ti ti-device-floppy"></i>
              Save Changes
            </button> -->
          </div>

          <!-- Loading / Error -->
          <div v-if="loading" class="text-muted small mb-2">Loading resources...</div>
          <div v-if="error" class="text-danger small mb-2">{{ error }}</div>

          <!-- Toolbar -->
          <div class="toolbar">

            <div class="role-select">
              <label>Resource List</label>

              <select class="form-select" style="font-size: 11px;">
                <option>Resource Code</option>
                <option>Resource Name</option>
                <option>Resource Type</option>
              </select>
            </div>

            <div class="search-box">
              <i class="ti ti-search"></i>

              <input
                type="text"
                placeholder="Search resource list..."
                v-model="search"
              >
            </div>

          </div>

          <!-- Buttons -->
          <div class="action-bar">

            <button class="outline-btn" @click="expandAll">
              <i class="ti ti-chevrons-down"></i>
              Expand All
            </button>

            <button class="outline-btn" @click="collapseAll">
              <i class="ti ti-chevrons-up"></i>
              Collapse All
            </button>

          </div>

          <!-- Tree (recursive — renders unlimited nesting depth) -->
          <div class="tree-card">

            <tree-node
              v-for="node in filteredTree"
              :key="node.id"
              :node="node"
              :depth="0"
              :selected-id="selectedResource && selectedResource.id"
              @select="selectNode"
              @add="addFolder"
              @edit="editFolder"
              @delete="deleteFolder"
              @toggle-checked="toggleChecked"
            />

          </div>

        </div>
      </div>

      <!-- Detail Panel -->
      <div class="col-md-6 mt-3">
        <div class="detail-panel-wrapper">

          <div v-if="detailLoading" class="text-muted small">Loading details...</div>
          <div v-else-if="detailError" class="text-danger small">{{ detailError }}</div>

          <div v-else-if="selectedResource" class="detail-panel">
            <h4>{{ selectedResource.resourceName }}</h4>

            <dl class="detail-list">
              <dt>Resource Code</dt>
              <dd>{{ selectedResource.resourceCode || '—' }}</dd>

              <dt>Resource Type</dt>
              <dd>{{ selectedResource.resourceType || '—' }}</dd>

              <dt>Module ID</dt>
              <dd>{{ selectedResource.moduleId || '—' }}</dd>

              <dt>Route Path</dt>
              <dd>{{ selectedResource.routePath || '—' }}</dd>

              <dt>Permission Key</dt>
              <dd>{{ selectedResource.permissionKey || '—' }}</dd>

              <dt>Display Order</dt>
              <dd>{{ selectedResource.displayOrder }}</dd>

              <dt>Menu Visible</dt>
              <dd>{{ selectedResource.isMenuVisible ? 'Yes' : 'No' }}</dd>

              <dt>Permission Controlled</dt>
              <dd>{{ selectedResource.isPermissionControlled ? 'Yes' : 'No' }}</dd>

              <dt>Active</dt>
              <dd>{{ selectedResource.isActive ? 'Yes' : 'No' }}</dd>
            </dl>
          </div>

          <div v-else class="text-muted small">
            Select a resource from the list to see its details.
          </div>

        </div>
      </div>
    </div>
  </div>
 <module-modal
  ref="moduleModal"
  :parent-options="flatParentOptions"
  @appresource-created="onResourceSaved"
  @appresource-updated="onResourceSaved"/>
</template>

<script>
import moduleListLogic from "./appresource.js";
import "./appresource.css";

export default moduleListLogic;
</script>

<style scoped>
.detail-panel-wrapper {
  padding: 1rem;
}

.detail-panel h4 {
  margin-bottom: 1rem;
}

.detail-list {
  display: grid;
  grid-template-columns: 160px 1fr;
  row-gap: 0.5rem;
  column-gap: 0.75rem;
}

.detail-list dt {
  font-weight: 600;
  color: #6b7280;
}

.detail-list dd {
  margin: 0;
}

.folder-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Common Button - no box, just icon (kept here too in case TreeNode's
   scoped styles ever get pulled out; harmless duplicate otherwise) */
.action-btn {
  width: auto;
  height: auto;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 4px;
  transition: 0.2s;
}

.action-btn i {
  font-size: 12px;
  transition: 0.2s;
}

/* Add - blue */
.add-btn i {
  color: #3b82f6;
}
.add-btn:hover i {
  color: #1d4ed8;
  transform: scale(1.15);
}

/* Edit - blue/indigo */
.edit-btn i {
  color: #4f46e5;
}
.edit-btn:hover i {
  color: #3730a3;
  transform: scale(1.15);
}

/* Delete - red/pink */
.delete-btn i {
  color: #f87171;
}
.delete-btn:hover i {
  color: #dc2626;
  transform: scale(1.15);
}
</style>